<template>
    <div class="bar-chart-component">
        <div v-if="title" class="chart-title" :style="{ 'text-align': textAlign }">{{ title }}</div>
        <div class="bar-chart" :style="{ 'border-radius': borderRadius, 'background-color': backgroundColor }">
            <div
                class="fill"
                :style="{ width: percentage, 'background-color': color, 'border-radius': borderRadius, height: height }"
            ></div>
        </div>
        <div v-if="showValues" class="absolute-values">
            {{ value }}/{{ total }}
        </div>
    </div>
</template>

<script>
export default {
    props: {
        color: {
            type: String,
            default: '#007bff'
        },
        title: {
            type: String,
            default: ''
        },
        borderRadius: {
            type: String,
            default: '50px'
        },
        textAlign: {
            type: String,
            default: 'left'
        },
        height: {
            type: String,
            default: '18px'
        },
        value: {
            type: Number,
            default: 1
        },
        total: {
            type: Number,
            default: 1
        },
        showValues: {
            type: Boolean,
            default: true
        },
        backgroundColor: {
            type: String,
            default: '#707070'
        }
    },
    computed: {
        percentage: function() {
            return `${(this.value / this.total) * 100}%`;
        }
    }
};
</script>

<style>
.bar-chart-component {
	width: 100%;
}
.bar-chart-component .chart-title {
	font-size: 18px;
	line-height: 24px;
	margin-bottom: 10px;
}
.bar-chart-component .bar-chart {
	background-color: #fff;
	width: 100%;
	overflow: hidden;
}
.bar-chart-component .absolute-values {
	font-size: 13px;
	font-weight: 700;
	line-height: 18px;
	margin-top: 4px;
	text-align: right;
}

@media screen and (max-width: 1366px) {
	.bar-chart-component .chart-title {
		font-size: 12px;
		line-height: 17px;
	}

	.bar-chart-component .absolute-values {
		font-size: 9px;
		line-height: 13px;
	}
}

@media screen and (max-width: 1280px) {

}

@media screen and (max-width: 992px) {
	.bar-chart-component .absolute-values {
		font-size: 7px;
		line-height: 9px;
	}
}

</style>
